import { CloudOff, Loader2, RefreshCw } from "lucide-react";

// Offline / waiting-to-sync banner for the event capture pages.
export const SyncBanner = ({ online, pending, syncing, onSync }) => {
  const count = pending.length;
  const failed = pending.filter((p) => p.error).length;
  if (online && count === 0) return null;
  return (
    <div
      data-testid="sync-banner"
      className={`mt-4 flex items-center gap-3 rounded-2xl px-4 py-3 ${online ? "bg-brand-gold/20 text-brand-charcoal" : "bg-brand-charcoal text-white"}`}
    >
      {online ? <RefreshCw className="h-5 w-5 shrink-0" /> : <CloudOff className="h-5 w-5 shrink-0 text-brand-gold" />}
      <div className="min-w-0 flex-1 text-[12.5px] leading-snug">
        <b>{online ? "Back online" : "No signal — still capturing"}</b>
        <span className="block opacity-75" data-testid="sync-banner-count">
          {count > 0
            ? `${count} saved on this phone, waiting to upload${failed ? ` (${failed} need attention)` : ""}`
            : "New cards and sign-ups are saved on this phone."}
        </span>
      </div>
      {online && count > 0 && (
        <button
          type="button"
          onClick={onSync}
          disabled={syncing}
          data-testid="sync-now"
          className="h-9 px-4 rounded-full bg-brand-charcoal text-white text-[11px] font-bold uppercase tracking-[0.1em] inline-flex items-center gap-1.5 disabled:opacity-60 shrink-0"
        >
          {syncing && <Loader2 className="h-3.5 w-3.5 animate-spin" />} Sync now
        </button>
      )}
    </div>
  );
};

export default SyncBanner;
